import React from 'react';
import ReactSlider from 'react-slider';
import cn from 'classnames';

const RangeSlider = ({key, renderThumb, renderTrack, ..._props}) => {
  const isVertical = _props.orientation === 'vertical';

  const defaultRenderThumb = (props, state) => {
    const isFirstThumb = state.index === 0;
    const isLastThumb = state.index === state.value.length - 1;

    let thumbColor;
    let tooltipBackground;
    let tooltipText;
    if (isFirstThumb) {
      thumbColor = 'bg-success';
      tooltipBackground = 'bg-success';
      tooltipText = 'Allow';
    } else if (isLastThumb) {
      thumbColor = 'bg-[#4A4A68]';
      tooltipBackground = 'bg-[#4A4A68]';
      tooltipText = 'Pending';
    } else {
      thumbColor = 'bg-indigo-500';
      tooltipBackground = 'bg-body';
      tooltipText = '';
    }

    return (
      <div {...props} className="relative top-[2px]">
        <div
          className={cn({
            'aspect-square h-[12px] w-[12px] rounded-full bg-white text-xs text-white flex items-center justify-center cursor-grab px-1': true,
            [thumbColor]: false,
          })}
        ></div>
        <div
          className={cn({
            "absolute bottom-[118%]  left-1/2 -translate-x-1/2 px-[5px] mb-[3px] py-[2px] w-fit text-white text-[8px] rounded after:content-[''] after:absolute after:block after:w-0 after:h-0 after:border-l-transparent after:border-l-4 after:border-b-4 after:border-r-transparent after:border-r-4 after:rotate-180 after:left-1/2 after:-translate-x-1/2 after:-bottom-[3px]": true,
            [tooltipBackground]: true,
            'after:border-b-success': isFirstThumb,
            'after:border-b-[#4A4A68]': isLastThumb,
          })}
        >
          {isFirstThumb || isLastThumb ? state.valueNow : tooltipText}
        </div>
      </div>
    );
  };

  const defaultRenderTrack = (props, state) => {
    const points = Array.isArray(state.value) ? state.value.length : null;
    const isMulti = points && points > 0;
    const isLast = isMulti ? state.index === points : state.index !== 0;
    const isFirst = state.index === 0;

    let trackColor;
    if (isMulti) {
      if (isFirst) {
        trackColor = 'bg-success';
      } else if (isLast) {
        trackColor = 'bg-status-404';
      } else {
        trackColor = 'bg-[#4A4A68]';
      }
    } else {
      trackColor = 'bg-grey';
    }

    return (
      <div
        {...props}
        key={`${props?.id}-${trackColor}`}
        className={cn({
          'h-1/4 top-1/2 -translate-y-1/2': !isVertical,
          'w-1/4 left-1/2 -translate-x-1/2': isVertical,
          'rounded-full': true,
          'bg-gray-200': isMulti ? isFirst || isLast : isLast,
          [trackColor]: true,
        })}
      ></div>
    );
  };

  return (
    <ReactSlider
      {..._props}
      renderThumb={renderThumb || defaultRenderThumb}
      renderTrack={renderTrack || defaultRenderTrack}
    />
  );
};

export default RangeSlider;
